<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i> Master AWB Status Listing  </strong>
            <div class="card-header-actions">                      
            </div>
          </div>  
          <!--  <div id="overlay" >
             <div class="loader"></div>
           </div>  -->
              <div id="printableArea" >
            <div class="page-break" v-for="item in masterawbdataarr" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.master_awb}}
                          <barcode v-bind:value="item.master_awb">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <span style ='font-size: 35px;  display: block;
  margin-bottom: 8px;'><b>{{item.master_awb}}</b></span> <br>
                         
                          <span style ='font-size: 30px;  display: block;
  margin-bottom: 8px;'>Country:<b> {{item.country}}</b></span><br>
                          <span style ='font-size: 30px; display: block;
  margin-bottom: 8px;' >Transport_mode:<b>{{item.transport_mode}}</b></span><br>
                          <!-- <span style ='font-size: 20px;'>Created_date: {{item.created_date}}</span><br>
                          <span style ='font-size: 20px;'>Created_by: {{item.created_by}}</span><br>
                          <span style ='font-size: 20px;'>Dispatch_date: {{item.dispatch_date}}</span><br>
                          -->
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
        <!--         <b-col md="6" >  
                  <b-form-group label="AWB Number" :label-cols="3"> 
                   <b-form-input class="input" type="text" name="masterawb" 
                   v-model="customer.masterawb" v-validate="'required'" 
                   :class="{'input': true, 'is-danger': errors.has('form-1.masterawb') }" placeholder="Enter AWB Number ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.masterawb')" class="help text-danger">{{ errors.first('form-1.masterawb') }}</span>
                   </b-form-group>          
                </b-col>  -->
               
              <!--   <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button> 
                               
                </b-col> -->
              </b-row>  
           <!--    <b-row> 
                <b-col md="12" >  
                <b-button style="display: none; float: right; " id="printbutton" variant="primary" size="md" value="print a div!" @click="barcodedata('printableArea')">Print AWB Details</b-button>
              </b-col>
            </b-row> -->
            
            
            </form>
          </div>  
          
         <b-col sm="12" class="text-right">
               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{totalRows }}</span></b> </p>
              </b-col> 
                    <div id="printableArea" >
            <div class="page-break" v-for="item in masterawbdata" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 2px;'>
                          <img id='test'/>
                          <div id="app" >
                                  {{item.master_awb}}
                          <barcode v-bind:value="item.master_awb">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <span style ='font-size: 35px;  display: block;
  margin-bottom: 8px;'><b>{{item.master_awb}}</b></span> <br>
                         
                          <span style ='font-size: 30px;  display: block;
  margin-bottom: 8px;'>Country:<b> {{item.country}}</b></span><br>
                          <span style ='font-size: 30px; display: block;
  margin-bottom: 8px;' >Transport_mode:<b>{{item.transport_mode}}</b></span><br>
                          <!-- <span style ='font-size: 20px;'>Created_date: {{item.created_date}}</span><br>
                          <span style ='font-size: 20px;'>Created_by: {{item.created_by}}</span><br>
                          <span style ='font-size: 20px;'>Dispatch_date: {{item.dispatch_date}}</span><br>
                          -->
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
            <b-col sm="12" >
            <b-table show-empty stacked="md" style="table-layout: fixed"  :busy="isBusy" :current-page="currentPage" :per-page="perPage" :items="masterawbdata" :bordered="bordered" :fields="fields"   :outlined="outlined"  >

             
              <template slot="istatus" slot-scope="row">
                
              <!--   <span>{{ (row.item.status==0)?'Created':'Dispatch'}} </span>  -->
              {{row.item.status}}
                
                </template>
                <template slot="actions" slot-scope="row">
             
             <input @change="setStickerHTMl($event,row.item)" type="radio" name="radAnswer" v-model="row.item.selected" style="position: absolute;right: 90px;margin-top: 4px;" class="awbcheckbox" id="stiker" :checked="checkedData" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b-button  v-if="!row.item.Dispatch" id="printbutton" variant="primary" size="sm" value="print a div!" @click="barcodedata('printableArea',row.item)" style="position: absolute;right: 17px;font-size:10px;background: #b0c4de !important;
    color: #000 !important;">Print Details</b-button>  <br>
                  <br>
                 <!-- <b-button    id="printbutton" variant="primary" size="sm" value="print a div!" @click="barcodedata('printableArea')" style="background: #b0c4de !important;color: #000 !important;">Print Zone </b-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
             
          
             <!-- {{row.item.master_awb}} -->
                   <b-button size="sm" @click="showinfoModal(row.item)" class="mr-1" data-toggle="tooltip" title="Master AWB Shipment"
                   style="position: absolute;font-size:10px;padding-left:8px;padding-right:8px;background: #b0c4de !important;margin-left:-4px;
    color: #000 !important;">
                    View Shipment
                  </b-button>
                  <br>
                  <br>
                   <b-button size="sm" @click="shipmentlogModal(row.item)" class="mr-1" data-toggle="tooltip" title="Master AWB Shipment Log"
                   style="position: absolute;font-size:10px;padding-left:8px;padding-right:8px;background: #b0c4de !important;margin-left:-4px;
    color: #000 !important;">
                  Shipment Log
                  </b-button>
                   <br>
                  <br>
                 <!--   <router-link
        to="/masterawbdetails"
      > <b-button size="sm" class="mr-1" style="padding-left: 20px;
    padding-right: 20px;
    margin-left: 2px;">
                    View Details
                  </b-button> </router-link>  -->
                 <router-link :to="{ name: 'masterawbdetails', params: { id: row.item.master_awb } }" style="text-decoration: none;
    color: black;
    font-size: 12px;
    border: 0.5px solid #b0c4de;
    padding: 5px;
        margin-left: -4px;
    background-color: #b0c4de !important;
    border-radius: 4px;" data-toggle="tooltip" title="Master AWB Details">
                   Details
                 </router-link>

                  <b-button size="sm" @click="showdimensionInfo(row.item)" style="margin-left:4px;background: #b0c4de !important;
    color: #000 !important;" class="mr-1"
                   data-toggle="tooltip" title="Edit Box Dimensions"
                   >
                   <i class="fa fa-pencil-square" aria-hidden="true"></i>
                  </b-button>
              
                </template>

                
             
               
                

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>           
            </b-table>
          </b-col>
           <b-modal size="lg" title="MAWB Shipment Log" v-model="shipmentlog" >
               <b-row>
            <b-col sm="12" class="text-right " >
                <b-button type="submit" variant="primary" size="md" @click="downloadCSV">Download </b-button>

              </b-col>

          </b-row>
            <div id="overlay" >
             <div class="loader"></div>
           </div> 
            <b-row>
              <b-col sm="12" class="text-right">
               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{total_row_logshipment }}</span></b> </p>
              </b-col> 
          </b-row>
           <!-- -->
    
          <div class="table-responsive-sm" v-for="(value, firstIndex) in logawblist">
                          <table class="table table-striped table-bordered" border="1" >
                      <thead  v-if="firstIndex ===0">
                        <tr>
                         <th>Shipping ID</th>
                          <th>AWB Title</th>
                          <th>Country Code</th>
                          <th>Mode Of Transport</th>
                          <th>Status</th>
                        
                           
                        </tr>
                      </thead>
                      <tbody v-if="firstIndex ===0">
                        
                        <tr v-for="log in shipmentloglist">
                          <td>{{log}}</td> 
                          <td>{{value.master_awb }}</td>
                          <td>{{value.country}}</td>
                          <td>{{value.transport_mode }}</td>
                           <td>{{value.status }}</td>
                        
                        </tr>
                      </tbody>
                    </table>
                  </div>
           </b-modal>

                <b-modal size="lg" title="MAWB Shipment List" v-model="editAgentMaster" >

          <!--@ok="editAgentMaster = false"
           <template slot="modal-header" slot-scope="{ close }">
          <h5>Shipment Listing</h5>
          </template> -->
         <!--  <b-row>
            <b-col sm="12" class="text-right " >
                <b-button type="submit" variant="primary" size="md" @click="downloadCSV">Download </b-button>

              </b-col>

          </b-row> -->
          <b-row>
              <b-col sm="12" class="text-right">
               <!--  <b-button v-if="this.totalRows >0"  variant="primary" size="md" @click="downloadCSV">Download </b-button>  -->
               <p > <b>Total Records :<span style="color:red;">{{total_row_shipment }}</span></b> </p>
              </b-col> 
          </b-row>

          <!--  <div class="table-responsive-sm" v-for="(value, firstIndex) in awblist">
                
                          <table class="table table-striped table-bordered" border="1" >
                      <thead >
                        <tr>
                         <th>Shipping ID</th>
                          <th>AWB Title</th>
                          <th>Country Code</th>
                          <th>Mode Of Transport</th>
                          <th>Status</th>
                          <th v-if="selected_status=='SkyEx Submitted'">Custom Invoice</th>
                           
                        </tr>
                      </thead>
                      <tbody >
                          {{shipmentlist}}
                        <tr v-for="list in shipmentlist">
                          <td>{{list}}</td> 
                          <td>{{value.master_awb }}</td>
                          <td>{{value.country}}</td>
                          <td>{{value.transport_mode }}</td>
                           <td>{{value.status }}</td>
                            <td v-if="selected_status=='SkyEx Submitted'">
                  <div v-if="value.status=='SkyEx Submitted' && customurl!=''">
                                  Download
                   <a :href="value.custominvoice_url" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Custom Invoice PDF" style="color: #3498db; margin-left: 5px;">&nbsp;</i></a>
                       </div>
                       <div v-else>
                         <span style="color:red">No Custom Invoice</span>
                       </div>
                     </td>
                        
                        </tr>
                      </tbody>
                    </table>
                  </div>  -->
                  <!--  <b-col md="12" class="my-1" v-if="total_row_shipment">
             <b-pagination v-model="modelcurrentPage" :total-rows="total_row_shipment" :per-page="modelperPage" ></b-pagination>
           </b-col> -->
                  <!-- {{awblist}} -->
          <b-table show-empty stacked="md"  :items="awblist" :busy="isBusy"  :fields="fields1" :current-page="shipcurrentPage" :per-page="shipperPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
            <template slot="actions" slot-scope="row">
              <!-- {{}} -->
             <div v-if="row.item.status=='SkyEx Submitted' && row.item.custominvoice_url!=''&&row.item.custominvoice_url!=null">
                Download
                <a :href="row.item.custominvoice_url" target="_blank"><i class="fa fa-download"
                      aria-hidden="true" data-toggle="tooltip" title="Custom Invoice PDF" style="color: #3498db; margin-left: 5px;">&nbsp;</i></a>
             </div>
             <div v-else>
               <span style="color:red">No Custom Invioce</span>
             </div>
            </template>

        
          </b-table>
          <b-col md="12" class="my-1 " v-if="total_row_shipment>10">
            <b-pagination
                v-model="shipcurrentPage"
                :total-rows="total_row_shipment"
                :per-page="shipperPage"
                class="my-0"
              ></b-pagination>
          </b-col> 
         <!--  <div >
     <label  v-if="shipmentlist.length>0"><b>Shipping id</b></label>
     <label v-else><b>Shippingid's are not Available</b> </label>
   </div> -->
   <!--  <div class="card-body">
          <div class="row" >
            <div class="row sm-12">
              <div class="col sm-12">
                
              
            
             <div   v-for="(item, index) in palletlist">
               <div v-if="index ===0">
                <h5>{{ item.pallet_title}}</h5>
               <strong>Shipping Id:</strong> {{ item.shippingid}} <br>
               <strong>Countrycode:</strong> {{ item.countrycode}} <br>
               <strong>Mode Of Transport:</strong> {{ item.modeoftransport}} <br>
               <strong>Count:</strong> {{ item.count}} <br>

              </div>
            </div> -->
          
        <!-- {{ item.shippingid}}<span >&nbsp;&nbsp;&nbsp;,</span> -->
       <!--      </div>
          </div>
      </div>
    </div> -->
    



    
         <!--  <template slot="modal-footer" slot-scope="{ hide }"> -->
            <!-- Emulate built in modal footer ok and cancel button actions -->
          <!--   <b-button size="sm"  @click="closeeditAgentMaster()" >
              Cancel
            </b-button> -->
            <!-- Button with custom close trigger value -->
          <!-- </template> -->
      </b-modal> 
             <b-col md="12" class="my-1 " v-if="totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col> 
              
<!--             
<table style="width:100%">
  
  <tr v-if="shippingidsdata.length >0">
    <th colspan="5">Shipping ID's :</th>
    
  </tr>

  <tr v-for="(item, index) in shippingidsdata">

    <td >{{ item.shippingid}}
    <br>

    </td>
     

</tr>
 
</table> -->
<div >
  <b-row > 
     <b-col md="12" >
   <!--    float: right; -->
  <b-button style="display: none; margin-bottom:2% " id="deletebutton" variant="primary" size="md" value="print a div!" @click="deleteshippingids(shippingidsdata)">Remove Shipping-Id</b-button>
</b-col>
</b-row>
</div>
<!-- <div >
     <label  v-if="shippingidsdata.length>0"><b>Shippingid's</b></label>
     <label v-else><b>Shippingid's are not Available</b> </label>
   </div> -->
    <div class="row" >
    
      <div class="col-md-2" style="margin-bottom:2%" v-for="(item, index) in shippingidsdata">
       
          <input type="checkbox" name="shippingid"   
          v-if="status =='Created'" @change="deleteshippment($event)"  v-model="checkedShipmentID"  v-bind:value="item.shippingid">
        {{ item.shippingid}}

      </div>
    </div>
    
 <!-- Master AWB Dimension -->

    <b-modal title="Master AWB Dimensions" v-model="awbDimension" @ok="awbDimension = false">
      <template slot="modal-header" slot-scope="{ close }">
          <h5>Master AWB Dimensions</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
                 <b-card-body>
                   <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
                     <b-form-group>
                      <div class="row mb-12">
                      <div class="col-sm-3">
                      <label for="dimensions length"> <strong>Box Length</strong></label>
                      </div>
                       <!-- <div class="col-sm-1">
                        <strong>:</strong>
                       </div> -->
                       <div class="col-sm-9">
                      <b-form-input type="text" name="length" v-model="dimensions.length" v-validate="'required|max:6'" :class="{'input': true, 'text-danger': errors.has('form-5.length') }" placeholder="Enter Length">                       
                       </b-form-input>
                    

                      <b-input-group >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('length')" ></i>
                      </span>
                      <span style="width:250px" v-show="errors.has('form-5.length')" class="help text-danger">{{ errors.first('form-5.length') }}</span>
                      </b-input-group>
                       </div>
                      </div>
                      </b-form-group>
                       <b-form-group>
                      <div class="row mb-12">
                      <div class="col-sm-3">
                      <label for="dimensions breadth"> <strong>Box Breadth</strong></label>
                      </div>
                       <!-- <div class="col-sm-1">
                        <strong>:</strong>
                       </div> -->
                       <div class="col-sm-9">
                      <b-form-input type="text" name="width" v-model="dimensions.width" v-validate="'required|max:6'" :class="{'input': true, 'text-danger': errors.has('form-5.width') }" placeholder="Enter Breadth">                       
                       </b-form-input>
                    

                      <b-input-group >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('width')" ></i>
                      </span>
                      <span style="width:250px" v-show="errors.has('form-5.width')" class="help text-danger">{{ errors.first('form-5.width') }}</span>
                      </b-input-group>
                       </div>
                      </div>
                      </b-form-group>
                        <b-form-group>
                      <div class="row mb-12">
                      <div class="col-sm-3">
                      <label for="dimensions height"> <strong>Box Height</strong></label>
                      </div>
                       <!-- <div class="col-sm-1">
                        <strong>:</strong>
                       </div> -->
                       <div class="col-sm-9">
                      <b-form-input type="text" name="height" v-model="dimensions.height" v-validate="'required|max:6'" :class="{'input': true, 'text-danger': errors.has('form-5.height') }" placeholder="Enter Height">                       
                       </b-form-input>
                    

                      <b-input-group >
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('height')" ></i>
                      </span>
                      <span style="width:250px" v-show="errors.has('form-5.height')" class="help text-danger">{{ errors.first('form-5.height') }}</span>
                      </b-input-group>
                       </div>
                      </div>
                      </b-form-group>
                    <!-- <div slot="footer" class="text-right">
                  <b-button variant="primary" size="md" type="submit" >Update</b-button>
                  &nbsp;
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div> -->
                 <footer class="column text-right">
                 <b-button variant="primary" size="md" type="submit" >Update</b-button>
                  &nbsp;
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </footer>
                   </b-form>
                 </b-card-body>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
    </b-modal>

 
              <!--  <b-table show-empty  hover stacked="md" style="table-layout: fixed" :outlined="outlined" :items="shippingidsdata" :bordered="bordered" 
               :fields="shippingidsFields" caption-top> -->
           <!--    <template slot="table-caption"><b>Shipping ID's</b></template> -->
           <!--    <template slot="shippingids"> -->
<!--             <table style="width:100%">
               <tr v-if="shippingidsdata.length >0">
    <th colspan="5">Shipping ID's :</th>
    
  </tr>
            <span  v-for="(item, index) in shippingidsdata"> {{ item.shippingid}}
             
        <span><b>,</b></span>
       
             <span v-if="[index]==3"> <br></span>
              
           
            </span>
          </table> -->
              <!-- </template> -->
              
         <!--    </b-table> -->
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueBarcode from 'vue-barcode';
export default {
  data: function () {
    return {
      isBusy: false,
      customer: {},
      dimensions:{
        length:null,
        width:null,
        height:null,
      },
      selected_master_awb:'',
      // dimensions_length:0,
      // dimensions_width:0,
      // dimensions_height:0,
      outlined:true,
      bordered: true,
      checkedData: false,
       currentPage: 1,
       modelcurrentPage:1,
       modelperPage:10,
         sortDesc: false,
        allowCustomValue : true,
        sortDirection: 'desc',
        filter: null,
        sortBy: null,
      data: [],
      totalRows: 0,
      shipperPage:10,
      shipcurrentPage:1,
      logcurrentPage:1,
      logperPage:1,
      total_row_shipment:0,
      perPage:  10,
      masterawbdataarr:[],
      pageOptions: [5, 10, 15],
      items: [],
      item:[],
      status:'',
      shipmentlist:[],
      customurl:'',
      // detailsshipmentlist:[],
       temp_list:[],
      awblist:[],
      shipmentloglist:[],
      logawblist:[],
      awbDimension:false,
      shipmentlog:false,
      editAgentMaster:false,
      selected_masterawb:'',
      selected_status:'',
        shippingidsdata: [],
        master:'',
      fields: [
      {key: 'master_awb', label: 'Master AWB'},
      {key: 'country',label:' For Country'},
      {key: 'transport_mode', label: 'Transfer Mode'},
      {key: 'istatus', label: 'Status'},
      {key: 'created_date', label: 'Created Date'},
      {key: 'created_by', label: 'Created By'},
      {key: 'updated_date', label: 'Dispatch Date'},
      {key: 'dimensions_length', label: 'Box Length'},
      {key: 'dimensions_width', label: 'Box Breadth'},
      {key: 'dimensions_height', label: 'Box Height'},
      { key: 'actions', label: 'Actions' ,tdClass: 'nameOfTheClass1'}],
      
   fields1: [
          { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'master_awb', label: 'AWB Title', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'country', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'transport_mode', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         { key: 'status', label: 'Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         { key: 'actions', label: 'Custom Invoice',tdClass: 'nameOfTheClass'}
       ], 
       logfields: [
          { key: 'shipping', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'master_awb', label: 'AWB Title', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
          { key: 'country', label: 'Country Code', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
           { key: 'transport_mode', label: 'Mode Of Transport', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         { key: 'status', label: 'Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
         // { key: 'actions', label: 'Custom Invoice'}
       ], 

     shippingidsFields:[{key:'shippingids' , label:'Shipping ID' }],
      checkedShipmentID:[],
      masterawbdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      selected_master_awb:'',

    }
  },
   components: {
    'barcode': VueBarcode
  },
  created: function () {
    this.getmasterawblisting();
  },
  methods: {
    //function for listing
    getmasterawblisting:function() {
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    const Obj_listing = {
            hub_id:`${userInfo.pickuplocationmasterid}`,
                }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawblist`,Obj_listing)
            .then((result) => {
           
           // console.log( result.body);
             
              if (result.body.returnmsg =="Successful") {
                 // document.getElementById("overlay").style.display = "none";
                this.masterawbdata = result.body.returnvalue
                  this.shippingidsdata = result.body.shipment
                  // console.log("awb", this.shippingidsdata);
                  // this.master=result.body.shipment.master_awb;
                  // console.log("ggg",this.master);
                  this.status=result.body.returnvalue[0].status
                 this.totalRows = result.body.returnvalue.length;
                 // document.getElementById("printbutton").style.display ="block";
               
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              } 
              else {
                //alert('Result not found')
                this.masterawbdata = []
                this.shippingidsdata = []
                

              
                this.isBusy = false;
                   // document.getElementById("overlay").style.display = "none";
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
      
    },
         setStickerHTMl(e,value){
          this.selected_master_awb=value.master_awb;
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
           this.masterawbdataarr=[];
          // alert("i m in setstiker")
          // alert(this.checkedData);
      // this.qrvalue="";
         this.checkedData=true;
    
 const obj = {

        master_awb:value.master_awb,
        country:value.country,
        transport_mode:value.transport_mode,

         hub_id:`${userInfo.pickuplocationmasterid}`,
       

      }

           this.masterawbdataarr.push(obj);


           

            // this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmasterawbdetails`,obj)
            // .then(result => {

              // this.masterawbdataarr = result.body.returnvalue;
               // this.qrvalue=result.body.returnvalue[0].pallet_id;
               
              
             // var qr =""+this.qrvalue;
              // alert(qr);

               // this.valuess=qr.trim();;
              //alert(this.valuess);

              // console.log(this.qrvalue)

            // })
            // .catch(ex => {
            //   console.log('error-----', ex)
            // });



    
    },
    // AWB Dimensions
    showdimensionInfo:function(value){
      // console.log("value",value);
      // this.customer.master_awb=value.master_awb;
      this.selected_master_awb=value.master_awb;
      // console.log("awb",this.customer.master_awb)
       this.dimensions.length = value.dimensions_length;
       this.dimensions.width = value.dimensions_width;
       this.dimensions.height = value.dimensions_height;
      this.awbDimension=!this.awbDimension;

    },
    updatedimensionInfo:function(value){

     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       //   this.customer.dimensions_length = value.dimensions_length;
       // this.customer.dimensions_width = value.dimensions_width;
       // this.customer.dimensions_height = value.dimensions_height;
      // this.awbDimension=!this.awbDimension;
      //   var result = [];
      //   var userdata = localStorage.getItem('userData')
      // var userInfo = JSON.parse(userdata)
      var Obj = {   
        master_awb:this.selected_master_awb,
         dimensions_length:this.dimensions.length,
         dimensions_width:this.dimensions.width,
         dimensions_height:this.dimensions.height,
        // master_awb:'BHR_ROAD_2021-04-06_1',
        hub_id:`${userInfo.pickuplocationmasterid}`,
      };  
       this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updateMasterAWBDimensions`,Obj)
        .then((result) => {
          // alert("in");
          // console.log("rrrr",result.body.returnmsg);
           if (result.body.returnmsg === "Successful"){
          // this.customer=result.body.returnvalue;
          // console.log('customer', this.item);
          alert("Updated Successfully");
          // this.$fire({
          //         text:"Updated Successfully",
          //         type: "success",
          //         timer: 30000
          //       }); 
           this.awbDimension = !this.awbDimension;
            this.dimensions = {};
            this.getmasterawblisting();
          }
          else
          {
           //  Utils.notify(result.body.returnvalue, "error");
           alert(result.body.returnvalue);
           // this.$fire({
           //        text:result.body.returnvalue,
           //        type: "error",
           //        timer: 30000
           //      });
          }
          this.awbDimension=false;

        })
        .catch(ex => {
            console.log("error", ex);
          });

    },
    editcancel:function() {
      this.dimensions = {};
        this.awbDimension = !this.awbDimension;
    },
    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        // console.log("r",result);
        if (result) {
          // console.log(this.dimensions);
          // alert("in");
           this.updatedimensionInfo();
           // this.getmasterawblisting();
        }
      });
    },
    shipmentlogModal:function(value){
            // alert(value.status);
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(value.pallet_id);
      //alert(" i m in info model");
      this.selected_status=value.status;
      this.selected_masterawb=value.master_awb;
      var Obj = {
          // pallet_id : value.pallet_id,
         // linehaulpallet_id: value.pallet_id,
        master_awb:value.master_awb,
        hub_id:`${userInfo.pickuplocationmasterid}`, 
      };  
       
  
// getshipmentlistfromlinehaulpallet

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmasterawbdetails`,Obj)
        .then((result) => {
          // console.log(result);
          if (result.body.returnmsg === 'Successful') {
            
          this.shipmentloglist = result.body.returnvalue.master_awb_details[0].shipment_list;
           console.log('pallet',this.shipmentloglist);
          
              this.logawblist=result.body.returnvalue.master_awb_details;

              // console.log("awblistttt",this.logawblist);
            
              this.total_row_logshipment=result.body.returnvalue.shipment_count;
              this.shipmentlog = true;
          } 
          else {
          this.logawblist=result.body.returnvalue;
          this.shipmentlog = true;
           this.shipmentloglist=[]; 
           this.total_row_logshipment=0; 
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })  
    },
    showinfoModal: function(value) {
      // alert(value.status);
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(value.pallet_id);
      //alert(" i m in info model");
      this.selected_status=value.status;
      this.selected_masterawb=value.master_awb;
      var Obj = {
          // pallet_id : value.pallet_id,
         // linehaulpallet_id: value.pallet_id,
        master_awb:value.master_awb,
        hub_id:`${userInfo.pickuplocationmasterid}`, 
      };  
       
  
// getshipmentlistfromlinehaulpallet

         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmasterawbdetails`,Obj)
        .then((result) => {
          // console.log(result);
          if (result.body.returnmsg === 'Successful') {
            
          this.shipmentlist = result.body.returnvalue.master_awb_details[0].shipment_list;
          //  // console.log('pallet',this.shipmentlist);
          //  for(var i=0;i<this.shipmentlist.length;i++){
          //   // alert("in");
          //   this.shipmentlist[i];
          //   // console.log("iii",i);
          //     this.temp_list.push( this.shipmentlist[i]);
          //     // console.log(this.shipmentlist[i]);
          //   }

               
          
           // this.master=result.body.returnvalue.master_awb;
           // console.log('ggg',this.master);
              this.awblist=result.body.returnvalue.master_awb_details;

              // console.log("awblistttt",this.awblist);
              // this.total_row_shipment=result.body.returnvalue.shipment_count;
              this.total_row_shipment=result.body.returnvalue.master_awb_details.length;
              // this.customurl=result.body.returnvalue.master_awb_details.custominvoice_url;
              // console.log("jjjj", this.total_row_shipment);
              this.editAgentMaster = true;
          } 
          else {
          this.awblist=result.body.returnvalue;
          this.editAgentMaster = true;
           this.shipmentlist=[]; 
           this.total_row_shipment=0; 
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })   
    },

 // Download CSV


downloadCSV: function() {
   document.getElementById("overlay").style.display = "block";
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata) 
 // alert(" i m i  Download");
 // alert(pagee);
 
      
          var csvObj = {
          
          sysusermasterid:`${userInfo.sysusermasterid}`, 
          hub_id:`${userInfo.pickuplocationmasterid}`, 
          master_awb:this.selected_masterawb,
            
           
          };
         
         
      

      // console.log(csvObj);
     
      
//         var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
     
      //var r = Math.random().toString(36).substring(3);
this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getMasterawbShipmentListcsv`,csvObj)
        .then(result => {
         // console.log(result);
          document.getElementById("overlay").style.display = "none";
          if(result.body=="success")
         {
         alert("Please Check Your Mail For Downlod Link")
          // this.$fire({
          //         text:"Please Check Your Mail For Downlod Link",
          //         type: "success",
          //         timer: 30000
          //       }); 
       }
       else
       {
        alert("Can not Download");
          // this.$fire({
          //         text:"Can not Download",
          //         type: "error",
          //         timer: 30000
          //       }); 
       }
        //window.location.href =result.url;
        });
        
    },






      barcodedata(printableArea,value){
  //alert(this.checkedData);
//this.checkedData=true;
if(this.checkedData==true && this.selected_master_awb==value.master_awb)
{
//alert(" i m in  if");

      //document.getElementById("printableArea").style.display = "none";

     var printContents = document.getElementById("printableArea").innerHTML;


     // var originalContents = document.body.innerHTML;
     // document.body.innerHTML = printContents;
     // window.print();
     // document.body.innerHTML = originalContents;


    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding: 10px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');


        //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');  


  

       docprint.document.write('</head><body onLoad="self.print()"><center>');



       // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');


        // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();
      // localStorage.removeItem("reloaded");
     // location.reloaded();
       //self.close();

}
else
{
  alert("Please Select Radion Button");
   // this.$fire({
   //                text:"Please Select Radion Button",
   //                type: "warning",
   //                timer: 30000
   //              }); 
}
    },
    deleteshippingids(data){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var created_by=userInfo.userfirstname+' '+userInfo.userlastname
      // console.log(data);
      if (confirm('Are you sure to Remove shippment ?')) {

         var shippingidobj = { 
            shippingid :this.checkedShipmentID ,
            master_awb: this.customer.masterawb ,
            created_by:created_by,
            hub_id:`${userInfo.pickuplocationmasterid}`,
         

            };
            document.getElementById("overlay").style.display = "block";


            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/removeshipmentsfrommasterawb`,shippingidobj)
            .then(result => {

            var result = result.body.returnmsg;
              if(result=="Successful")

              alert('Shippment Removed Successfully.');
            document.getElementById("deletebutton").style.display ="none";
             const obj = {
             master_awb: this.customer.masterawb,
            // master_awb:"UAE676696"
          hub_id:`${userInfo.pickuplocationmasterid}`,
          }
          // console.log(obj);

         // this.isBusy = true;
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getmasterawbdetails`,obj)
            .then((result) => {
           
           // console.log( result.body.shipment);
             
              if (result.body.returnmsg =="Successful") {
                 document.getElementById("overlay").style.display = "none";

                this.masterawbdata = result.body.returnvalue
                  this.shippingidsdata = result.body.shipment
                
               
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              } else {
                //alert('Result not found')
                this.masterawbdata = []
                this.shippingidsdata = []
                

              
                this.isBusy = false;
                // var searchlisting = document.getElementById('searchlisting2')
                // searchlisting.style.display = 'block'
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })

            })
            .catch(ex => {
              console.log('error-----', ex)
            });

        
  
  
} else {
 
  alert('Shippment Can Not be Delete .');
}
       
    },


        deleteshippment(e){
 var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // console.log(this.checkedShipmentID);
        if (this.checkedShipmentID.length >0)

        {
          // alert(this.checkedShipmentID.length)

            document.getElementById("deletebutton").style.display ="block";

           


        }
        else{
         document.getElementById("deletebutton").style.display ="none";
        }

    },

//        barcodedata(printableArea){


//       //document.getElementById("printableArea").style.display = "none";

//      var printContents = document.getElementById("printableArea").innerHTML;


//      // var originalContents = document.body.innerHTML;
//      // document.body.innerHTML = printContents;
//      // window.print();
//      // document.body.innerHTML = originalContents;


//     var disp_setting="toolbar=yes,location=no,";
//     disp_setting+="directories=yes,menubar=yes,";
//     disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
//        var content_vlue = printContents;
//        var docprint=window.open("","",disp_setting);
//        docprint.document.open();
//        docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
//       docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
//       docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
//       docprint.document.write('<head>');
//       docprint.document.write('<style type="text/css">body{ margin:0px;');
//       docprint.document.write('font-family:verdana,Arial;color:#000;');
//       docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
//       docprint.document.write('a{color:#000;text-decoration:none;} ');
//       docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
//       docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

//       docprint.document.write('.addpad{ padding: 10px; }');


//        docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

// docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


//         docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

//         docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');


//         //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');  


  

//        docprint.document.write('</head><body onLoad="self.print()"><center>');



//        // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');


//         // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
//        docprint.document.write(content_vlue);
// docprint.document.write('</center></body></html>');
//            docprint.document.close();
//       // localStorage.removeItem("reloaded");
//      // location.reloaded();
//        //self.close();


//     },
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')
       document.getElementById("printbutton").style.display ="none";
          this.masterawbdata = []
          this.shippingidsdata = []
           document.getElementById("deletebutton").style.display ="none";
      
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
};
</script>
<style>
  .b-table-caption-top{
    color: black;
  }
  .shipping table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
th, td {
  padding: 5px;
  text-align: left;    
}

  .nameOfTheClass1 {
  width:260px ;
  white-space: nowrap;
   
}
#overlay1 {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader1 {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  /*display: none;*/ /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 9999; /* Specify a stack order in case you using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
</style>
